<template>
  <span class="badge" :class="[variantClass, solid && 'badge-solid', size === 'xs' && 'badge-xs']">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue"

/**
 * Status badge/pill (wraps the global .badge vocabulary). Pick a semantic
 * variant instead of inlining colors — "paused" is warning, "recurring" is
 * accent, etc. `solid` swaps the subtle tint for a filled variant background
 * (the "current plan" / "popular" ribbons on the subscription tiers).
 */
const props = withDefaults(
  defineProps<{
    variant?: "neutral" | "success" | "warning" | "danger" | "info" | "accent"
    size?: "xs" | "md"
    /** Filled background instead of the subtle tint. */
    solid?: boolean
  }>(),
  { variant: "neutral", size: "md" },
)

const variantClass = computed(
  () =>
    ({
      neutral: "badge-neutral",
      success: "badge-success",
      warning: "badge-warning",
      danger: "badge-danger",
      info: "badge-info",
      accent: "badge-accent",
    })[props.variant],
)
</script>
